<template>
  <div class="room">
      <blue-print :bridgeId="bridgeId"></blue-print>
  </div>
</template>
<script>
import BluePrint from '../../components/BluePrint'

export default {
  name: 'bridgeImg',
  components: { BluePrint },
  data() {
    return {
        bridgeId: '8c363c2c-8e86-499d-80a5-b3718fd4b102'
    }
  },
}
</script>